import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import MaterialTable, { MTableToolbar } from 'material-table';
import { Container, createMuiTheme, Toolbar, Typography, CssBaseline, IconButton, Snackbar, Divider, Fab, AppBar } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext';
import { Theme } from '../contexts/themeContext';
import { TransactionTime } from '../common/transactionTime';
import Card from '../card/card.js';
import CardBody from '../card/cardBody.js';
import RdoAccountVisitationAdd from './rdoAccountVisitationAdd';
import RdoDirectorActionAdd from './directorActionAdd';
import Grid from '@material-ui/core/Grid';
import { OfflineService } from "../../offline/storageService/offlineService";
import { LoadRDOSectionsForAll } from "../../offline/dataService/rdoAccountVisitationOfflineData";
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    }
}));

export default function RdoAccountVisitationList(props) {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const rdoAccountVisitationRef = useRef();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [open, setOpen] = useState(false);
    const [isRdoAccountVisitationAdd, setIsRdoAccountVisitationAdd] = useState(false);
    const [isRdoDirectorActionAdd, setIsRdoDirectorActionAdd] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [successMessage] = useState('');
    const [action, setAction] = useState('');
    const [rdoAccountVisitationSelected, setRdoAccountVisitationSelected] = useState(null);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const [allRDOSections] = useState([]);
    const [modified, setModified] = useState(false);
    const tableHeight = window.innerHeight - 200;

    const [filter, setFilter] = useState(
        {
            SiteId: defaultSite.id,
            StartDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite),
            EndDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite)
        });

    const [rdoAccountVisitations, setRdoAccountVisitations] = useState({
        columns: [
            { field: 'CreatedDateTimeString', title: 'Date', width: '10%' },
            { field: 'SiteName', title: 'Site'},
            { field: 'Director', title: 'Director' },
            { field: 'RDO', title: 'RDO'},
            { field: 'RDORating', title: 'RDO Rating'},
            { field: 'SectionsCompleted', title: 'Sections Completed', render: rowData => (rowData.SectionsCompleted +"/5")}
        ],
        data: []
    });
    
    const triggerSave = () => {
        if (isRdoDirectorActionAdd) {
            closeRdoDirectorActionAdd();
        }
        else {
            rdoAccountVisitationRef.current.save();
        }
    };

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const inputValueChanged = () => {
        setModified(true);
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
    };

    const openAddRdoAccountVisitation = () => {
        setOpen(true);
        setIsRdoAccountVisitationAdd(true);
        setAction('Add');
        setRdoAccountVisitationSelected(null);
    };

    const closeAddRdoAccountVisitation = () => {
        setModified(false);
        TransactionTime.cancel();
        if (props.rdoAccountVisitationSelected) {
            props.history.push({ pathname: '/RdoAccountVisitationList' });
        }
        else {
            setOpen(false);
            setIsRdoAccountVisitationAdd(false);
            setAction('');
        }
        getRdoAccountVisitations();
        refreshOfflineData();
    };

    const closeRdoDirectorActionAdd = () => {
        if (props.rdoAccountVisitationSelected) {
            props.history.push({ pathname: '/RdoAccountVisitationList' });
        }
        else {
            setOpen(false);
            setIsRdoDirectorActionAdd(false);
            setAction('');
        }

    };

    const editRdoAccountVisitation = (rowData) => {
        setRdoAccountVisitationSelected(rowData);
        setOpen(true);
        setIsRdoAccountVisitationAdd(true);
        setAction('Edit');
    };

    const showDirectorActionAdd = (rowData) => {
     
        if (sessionStorage.getItem("isOffline") === "1") {
            setErrorMessage("Director Action is unavailable in Offline Mode. Please connect to the internet.");
            setOpenError(true);
            return;
        }
        if (rowData.SectionsCompleted !== 5) return;
        setIsRdoDirectorActionAdd(true);
        setOpen(true);
        setRdoAccountVisitationSelected(rowData);
    };

    const startDateChanged = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        setFilter({ ...filter, StartDate: date });
    };

    const endDateChanged = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        setFilter({ ...filter, EndDate: date });
    };

    const refreshOfflineData = () => {
        let date = ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite);
        LoadRDOSectionsForAll(defaultSite, date);
    };

    const getRdoAccountVisitations = () => {

        setBackDrop(true);
        HttpService.post('/RDOAccountVisitation/GetRDOAccountVisitations',
            {
                SiteId: filter.SiteId,
                DateStart: filter.StartDate,
                DateEnd: filter.EndDate
            }
        )
        .then(async (result) => {
            setBackDrop(false);

            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "GetRDOAccountVisitations");
                setRdoAccountVisitations({ ...rdoAccountVisitations, data: offlineResult.OfflineData });
            }
            else {
                setRdoAccountVisitations({ ...rdoAccountVisitations, data: result.rdoAccountVisits });
                offlineService.removeOfflineBySite(defaultSite.id, "GetRDOAccountVisitations");
                offlineService.addOffline(defaultSite.id, "GetRDOAccountVisitations", result.rdoAccountVisits);
            }
        },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
    };

    useEffect(() => {
        if (action === "") {
            getRdoAccountVisitations();
            refreshOfflineData();
        }
        // eslint-disable-next-line 
    }, [filter.StartDate, filter.EndDate]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="rdoAccountVisitationBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeErrorSnackbar} severity="error">
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            {!open && <Link to="/"><KeyboardBackspaceIcon /></Link>}
                            {open &&
                                <IconButton edge="start" color="inherit" onClick={triggerSave} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                            }
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Typography variant="h6" className={classes.title}>&nbsp;{action} RDO Account Visitation</Typography>
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-end" spacing={2}>
                                {!open && <Fab style={{ background: currentTheme.secondary, color: 'white' }} size="small" aria-label="add" onClick={openAddRdoAccountVisitation}>
                                    <AddIcon />
                                </Fab>
                                }
                                {
                                    open && isRdoAccountVisitationAdd &&
                                    <Fab style={{ background: currentTheme.secondary, color: 'white' }} size="small" aria-label="close" onClick={closeAddRdoAccountVisitation}>
                                        <CloseIcon />
                                    </Fab>
                                }
                                {
                                    open && isRdoDirectorActionAdd &&
                                    <Fab style={{ background: currentTheme.secondary, color: 'white' }} size="small" aria-label="close" onClick={closeRdoDirectorActionAdd}>
                                        <CloseIcon />
                                    </Fab>
                                }
                                <SmallMenu moduleName={"RDOAccountVisitation"} modified={modified} />
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            <div className={classes.root} autoComplete="off">
                                {!open &&
                                    <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}>
                                        <Grid item xs={12} sm={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="Date"
                                                    label="Date"
                                                    format="MM/dd/yyyy"
                                                    size="small"
                                                    disableFuture="true"
                                                    value={filter.StartDate}
                                                    onChange={date => startDateChanged(date)}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="EndDateTime"
                                                    label="End Date"
                                                    format="MM/dd/yyyy"
                                                    size="small"
                                                    value={filter.EndDate}
                                                    onChange={date => endDateChanged(date)}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                    </Grid>
                                }
                                {!open && 
                                    <Divider style={{ height: '1px', backgroundColor: currentTheme.secondary, marginTop: '5px', marginBottom: '10px' }} />
                                }
                            </div>

                            <div style={{ maxWidth: '100%' }}>
                                {!open &&
                                    <MaterialTable
                                        title=""
                                        columns={rdoAccountVisitations.columns}
                                    data={rdoAccountVisitations.data}
                                    localization={{
                                        header: {
                                            actions: 'Director Action'
                                        }
                                    }}
                                        onRowClick={(event, rowData) => { editRdoAccountVisitation(rowData); }}
                                        components={{
                                            Toolbar: (props) => (
                                                <div
                                                    style={{
                                                        height: "0px",
                                                    }}
                                                >
                                                    <MTableToolbar {...props} />
                                                </div>
                                            )
                                        }}
                                        style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                                        options={{
                                            filtering: false,
                                            search: false,
                                            paging: false,
                                            actionsColumnIndex: -1,
                                            minBodyHeight: tableHeight,
                                            maxBodyHeight: tableHeight,
                                            headerStyle: {
                                                fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                            },
                                            actionsCellStyle: {
                                                color: currentTheme.secondary,
                                                hover: 'white'
                                            },
                                            rowStyle: rowStyle
                                    }}
                                    actions={[
                                        rowData => ({
                                            icon: () => (<img src={require('../../images/icon_clipboard-provblue.png')} style={{ width: 20 }} alt="" />),
                                            tooltip: 'Director Action',
                                            title: 'DirectorAction',
                                            onClick: (event, rowData) => { showDirectorActionAdd(rowData); }
                                        }),
                                    ]}
                                    />
                                }

                                {
                                    open && isRdoAccountVisitationAdd && <RdoAccountVisitationAdd ref={rdoAccountVisitationRef}
                                    parentCallback={closeAddRdoAccountVisitation}
                                    refreshGrid={getRdoAccountVisitations}
                                    rdoAccountVisitationSelected={rdoAccountVisitationSelected}
                                    allRDOSections={allRDOSections}
                                    action={action}
                                    theme={currentTheme}
                                    inputValueChanged={inputValueChanged}
                                    />
                                }

                                {
                                    open && isRdoDirectorActionAdd && <RdoDirectorActionAdd ref={rdoAccountVisitationRef}
                                        parentCallback={closeRdoDirectorActionAdd}
                                        rdoAccountVisitationSelected={rdoAccountVisitationSelected}
                                        theme={currentTheme}
                                    />
                                }


                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
